<div>
  <app-button data-qa="notifications-shared-personal"
    [type]="buttonType"
    [matMenuTriggerFor]="menu"
    [showIcon]="'right'"
    [size]="'xsmall'"
    [additionalClasses]="additionalClass"
    [iconName]="'white-arrow-down.svg'">
    {{displayedItem}}
  </app-button>
  <mat-menu #menu="matMenu" class="rounded-list">
    <ul class="min-width-7p5  bg-white-12  rounded-list br-0p25 pd-top-0p25">
      <li  class="table-menu-item border-radius-1p5" (click)="itemEmitter.emit(simpleData[0])">
        <span class="opacity0p88 font-5">{{simpleData[0]}}</span>
      </li>
    </ul>
  </mat-menu>

</div>
